import classNames from 'classnames';

export default function DateLabel({ value, alignRight }) {

    const date = new Date(value);
    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };

    const topClassNames = classNames('entry-date',
        alignRight ? 'entry-date-right' : 'entry-date-left' );

    return (
        <div className={topClassNames}>
            <div className="entry-date-arow"></div>
            <i className="fa fa-image"></i>
            <span>{date.toLocaleDateString('uk-UA', dateOptions)}</span>
        </div>
    );
}